import axios from 'axios';

import URLS from '../../util/urls';

const state = {
  listaImoveis: []
};

const mutations = {
  atualizarListaImoveis(state, payload) {
    state.listaImoveis = payload;
  },

  limparImoveis(state) {
    state.listaImoveis = [];
  },
};

const actions = {
  recuperarUltimosImoveisVenda(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_ULTIMOS_IMOVEIS_VENDA)
      .then((response) => {
        switch(response.data.status) {
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
            .then(authResponse => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('recuperarUltimosImoveisVenda');
              }
            }).catch((error) => {
              throw error;
            });
          default:
            return context.commit('atualizarListaImoveis', response.data.lista);
        }
      }).catch((error) => {
        throw error;
      });
  }
};

export default {
  state,
  mutations,
  actions
};